module.exports = __webpack_public_path__ + "static/CL_logo-fe7aad75d50df9f1c69c4fe926eebbe9.png";